/**
 * Hoppscotch writes variables as `<<name>>` (hoppscotch-data
 * `environment/index.ts`, `REGEX_ENV_VAR = /<<([^>]*)>>/g`); Apiboo uses
 * `{{name}}`. Applied to every request FIELD — url, params, headers, bodies,
 * form values, auth strings, variable values — and NEVER to scripts: a script
 * reads variables by name (`pw.env.get('x')`), and rewriting its source would
 * change string literals the author meant literally.
 */
const HOPP_VAR = /<<([^<>\s]+)>>/g;

export function convertHoppVars(value) {
  if (typeof value !== 'string') return value == null ? '' : String(value);
  return value.replace(HOPP_VAR, '{{$1}}');
}
